"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireWildcard(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ErrorHandler = _ref => {
  let {
    error,
    show
  } = _ref;
  const ref = (0, _react2.useRef)();
  const [anchorEl, setAnchorEl] = _react2.default.useState(null);
  (0, _react2.useEffect)(() => {
    if (show && ref.current) {
      handleOpen();
    }
  }, [show]);
  const handleOpen = event => {
    if (ref.current) {
      setAnchorEl(ref.current);
    }
  };
  const handleClose = event => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? _lodash.default.uniqueId('errorHandler_') : undefined;
  const errors = _lodash.default.isArray(error) ? error : [error];
  _lodash.default.each(errors, error => {
    if (_lodash.default.has(error, 'trace')) error.trace();else console.error(error);
    const data = {
      ..._lodash.default.pick(error, ['message', 'code', 'stack', 'locations']),
      ..._lodash.default.mapKeys(_lodash.default.pick(error.extensions, ['code', 'stacktrace']), (v, k) => "extensions.".concat(k))
    };
    Sentry.addBreadcrumb({
      category: 'auth',
      data,
      message: "Internal server error rendering section",
      level: 'error'
    });
  });
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(_material.Container, {
    ref: ref,
    maxWidth: "md",
    my: 3
  }, /*#__PURE__*/_react2.default.createElement(_material.Alert, {
    severity: "error",
    action: /*#__PURE__*/_react2.default.createElement(_material.IconButton, {
      color: "error",
      onClick: handleOpen,
      title: "Learn More and Report"
    }, /*#__PURE__*/_react2.default.createElement(_iconsMaterial.Help, null))
  }, /*#__PURE__*/_react2.default.createElement(_material.AlertTitle, null, /*#__PURE__*/_react2.default.createElement(_material.Typography, {
    component: "div",
    variant: "h4",
    gutterBottom: true
  }, /*#__PURE__*/_react2.default.createElement("span", {
    translate: "no"
  }, "Sumimasen"), " (", /*#__PURE__*/_react2.default.createElement("span", {
    lang: "ja"
  }, "\u3059\u307F\u307E\u305B\u3093"), ")\u2026something went terribly wrong and, this section cannot be displayed."), /*#__PURE__*/_react2.default.createElement(_material.Typography, {
    paragraph: true
  }, "Why not try refreshing your page? Or you can", ' ', /*#__PURE__*/_react2.default.createElement(_material.Link, {
    href: "/contact-us"
  }, "leave us feedback"), " if the problem persists.")))), /*#__PURE__*/_react2.default.createElement(_material.Dialog, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose
  }, /*#__PURE__*/_react2.default.createElement(_material.DialogTitle, null, "Internal Error Details"), /*#__PURE__*/_react2.default.createElement(_material.DialogContent, null, /*#__PURE__*/_react2.default.createElement(_material.Typography, {
    variant: "subtitle1"
  }, _lodash.default.get(error, 'message', 'Unknown Error')), process.env.NODE_ENV !== 'production' && _lodash.default.map(['code', 'extensions.code', 'locations'], key => {
    if (_lodash.default.has(error, key)) {
      return /*#__PURE__*/_react2.default.createElement(_material.Box, {
        key: key
      }, /*#__PURE__*/_react2.default.createElement(_material.Typography, {
        variant: "subtitle2"
      }, _lodash.default.capitalize(key)), /*#__PURE__*/_react2.default.createElement(_material.Typography, {
        paragraph: true
      }, _lodash.default.get(error, key)));
    }
    return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, {
      key: key
    });
  })), /*#__PURE__*/_react2.default.createElement(_material.DialogActions, null, /*#__PURE__*/_react2.default.createElement(_material.Stack, {
    direction: "row",
    gap: 2
  }, /*#__PURE__*/_react2.default.createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    onClick: e => {
      handleClose(e);
      Sentry.showReportDialog();
    }
  }, "Report It"), /*#__PURE__*/_react2.default.createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    href: "/contact-us"
  }, "Contact Us")))));
};
ErrorHandler.defaultProps = {};
ErrorHandler.propTypes = {
  error: _propTypes.default.any.isRequired
};
var _default = exports.default = ErrorHandler;